import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/element-ui/style/theme/index.css";
import locale from "element-ui/lib/locale/lang/ru-RU"; // lang i18n // lang i18n

import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { formatDateWithoutTimezone } from "@/utils";

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";

import "@/icons"; // icon
import "@/permission"; // permission control

import "trix/dist/trix.css";

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.filter("formatDate", (date) => {
  return date
    ? format(formatDateWithoutTimezone(date), "d MMMM yyyy", { locale: ru })
    : "";
});

Vue.filter("formatDateTime", (date) => {
  return date
    ? format(formatDateWithoutTimezone(date), "d MMMM yyyy HH:mm", {
        locale: ru,
      })
    : "";
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
